import { Code2, Bot, BarChart3, PenTool, Megaphone, Plus, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const skills = [
    {
        title: "Software Development",
        description: "Full-stack engineering with modern frameworks like React and Next.js, focused on scalable architectures.",
        icon: Code2,
    },
    {
        title: "AI Automation",
        description: "Streamlining business workflows with intelligent agents, custom LLM integrations, and automated pipelines.",
        icon: Bot,
    },
    {
        title: "Data Analysis",
        description: "Turning complex datasets into actionable business insights with interactive visualizations and modeling.",
        icon: BarChart3,
    },
    {
        title: "UI/UX Research",
        description: "Conducting user research, analyzing user behavior, and identifying insights to design intuitive, user-centered digital experiences with a strong focus on usability and accessibility.",
        icon: PenTool,
    },
    {
        title: "Advertising Design",
        description: "Crafting compelling visual narratives and high-impact marketing assets that convert and build brand equity.",
        icon: Megaphone,
    },
];

export default function Services() {
    return (
        <section id="skills" className="py-24 bg-background relative overflow-hidden">
            {/* Background Blob */}
            <div className="absolute top-1/2 left-0 w-[500px] h-[500px] bg-neon/5 rounded-full blur-[100px] -z-10 -translate-y-1/2 -translate-x-1/2 pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header Section */}
                <div className="flex flex-col items-center text-center mb-16 space-y-4">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-neon/10 text-black text-xs font-bold uppercase tracking-wider border border-neon/20">
                        <span className="w-2 h-2 rounded-full bg-neon animate-pulse shadow-[0_0_8px_rgba(228,255,48,0.5)]"></span>
                        Expertise
                    </div>

                    <h2 className="text-4xl md:text-5xl font-display font-black text-foreground tracking-tight">
                        Skills & <span className="text-neon inline-block transition-transform hover:scale-105 duration-300 drop-shadow-sm">Expertise</span>
                    </h2>

                    <p className="max-w-2xl text-lg text-muted-foreground leading-relaxed">
                        A multi-disciplinary approach to building digital products and experiences.
                        Specialized in bridging the gap between design and engineering.
                    </p>
                </div>

                {/* Grid Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {skills.map((skill, index) => (
                        <div
                            key={index}
                            className="bg-card rounded-[2rem] p-8 shadow-sm hover:shadow-2xl hover:shadow-neon/10 transition-all duration-300 flex flex-col items-start group border border-border/40 hover:border-neon/50 relative overflow-hidden"
                        >
                            <div className="absolute top-0 right-0 w-24 h-24 bg-neon/5 rounded-bl-[4rem] transition-all duration-500 group-hover:bg-neon/10 pointer-events-none" />

                            <div className="w-14 h-14 rounded-2xl bg-black flex items-center justify-center mb-6 text-neon group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300 shadow-lg shadow-neon/5">
                                <skill.icon className="w-7 h-7" />
                            </div>

                            <h3 className="text-xl font-bold text-foreground mb-3 font-display">
                                {skill.title}
                            </h3>

                            <p className="text-muted-foreground leading-relaxed mb-8 flex-grow">
                                {skill.description}
                            </p>

                            <Button
                                className="bg-black text-white hover:bg-neon hover:text-black rounded-xl px-6 h-11 font-bold group-hover:pl-8 transition-all duration-300 w-full justify-between border border-transparent hover:border-black/5"
                            >
                                Explore <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                            </Button>
                        </div>
                    ))}

                    {/* Coming Soon Card */}
                    <div className="bg-transparent rounded-[2rem] p-8 border-2 border-dashed border-border flex flex-col items-center justify-center min-h-[320px] text-center hover:border-neon/50 hover:bg-neon/5 transition-all duration-300 group cursor-pointer relative overflow-hidden">

                        <div className="w-16 h-16 rounded-full bg-muted text-muted-foreground flex items-center justify-center mb-6 group-hover:bg-black group-hover:text-neon transition-colors duration-300 relative z-10 shadow-sm group-hover:shadow-neon/20">
                            <Plus className="w-8 h-8 transition-transform group-hover:rotate-90 duration-300" />
                        </div>
                        <h3 className="text-lg font-bold text-muted-foreground group-hover:text-foreground transition-colors duration-300 relative z-10 font-display">
                            More Skills Coming Soon
                        </h3>
                    </div>
                </div>
            </div>
        </section>
    );
}
